import FontHeading4 from '../../../../../../components/fonts/font-heading4/font-heading4';
import { FONT_COLOR, FONT_VARIANT } from '../../../../../../components/fonts/font-props';
import camera from '../../../../../../images/camera.svg';
import './image-upload-view.scss';

interface Props {
    required?: boolean
}

const ImageUploadView: React.FC<Props> = ({ required }) => {
    const requiredClass = required ? ' required' : '';
    return (
        <div className="answer-image-upload">
            <div className={`answer-image-upload-inner${requiredClass}`}>
                <img src={camera} alt="" />
                <FontHeading4 variant={[FONT_VARIANT.BOLD]} color={FONT_COLOR.PRIMARY3}>Upload image</FontHeading4>
            </div>
        </div>
    );
}

export default ImageUploadView;
